import React, { ReactElement, ReactNode } from "react";
import styles from "./loginContentWrapper.module.scss";

type LoginContentWrapperProps = {
  children?: ReactElement | ReactElement[];
  title: ReactNode;
  byline?: ReactNode;
};

const LoginContentWrapper = ({
  children,
  title,
  byline,
}: LoginContentWrapperProps): React.JSX.Element => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      {byline && <div>{byline}</div>}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default LoginContentWrapper;
